import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface ShopSettings {
  // Cửa hàng
  shopName: string
  slogan: string
  description: string
  address: string
  workingHours: string
  logoUrl: string
  faviconUrl: string

  // Liên hệ
  hotline: string
  email: string
  facebookUrl: string
  youtubeUrl: string
  instagramUrl: string
  zaloPhone: string

  // Ngân hàng
  bankBin: string
  bankShortName: string
  bankAccountNo: string
  bankAccountName: string
  qrEnabled: boolean
  codEnabled: boolean

  // Vận chuyển
  freeShippingThreshold: number
  defaultShippingFee: number
  returnPolicyDays: number
  warrantyMonths: number
}

export const DEFAULT_SETTINGS: ShopSettings = {
  shopName: 'Xe Điện Việt',
  slogan: 'Di chuyển xanh — Cuộc sống đẹp hơn',
  description: 'Chuyên cung cấp xe máy điện, xe đạp điện chính hãng — bảo hành dài hạn, giao hàng toàn quốc.',
  address: '123 Đường Lê Lợi, Quận 1, TP. Hồ Chí Minh',
  workingHours: 'Thứ 2 — Chủ nhật: 8:00 — 20:00',
  logoUrl: '',
  faviconUrl: '',

  hotline: '1800 1234',
  email: 'hello@xediendviet.vn',
  facebookUrl: 'https://facebook.com/xediendviet',
  youtubeUrl: 'https://youtube.com/@xediendviet',
  instagramUrl: 'https://instagram.com/xediendviet',
  zaloPhone: '0912345678',

  bankBin: '970436',
  bankShortName: 'Vietcombank',
  bankAccountNo: '0123456789',
  bankAccountName: 'NGUYEN LE ANH HIEU',
  qrEnabled: true,
  codEnabled: true,

  freeShippingThreshold: 5_000_000,
  defaultShippingFee: 50_000,
  returnPolicyDays: 7,
  warrantyMonths: 36,
}

interface SettingsState {
  settings: ShopSettings
  update: (patch: Partial<ShopSettings>) => void
  reset: () => void
}

export const useAdminSettingsStore = create<SettingsState>()(
  persist(
    (set, get) => ({
      settings: DEFAULT_SETTINGS,
      update: (patch) => set({ settings: { ...get().settings, ...patch } }),
      reset: () => set({ settings: DEFAULT_SETTINGS }),
    }),
    {
      name: 'xedien.admin.settings.v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ settings: s.settings }),
    },
  ),
)
